/**
 * Track action labels — one vocabulary for two different actions that were
 * getting confused under overlapping labels ("Create Track" / "New Track" /
 * "Create track" / "Add track" all meant *create*, except TrackIndex's
 * "Add Track", which meant *attach an existing standalone Track to this
 * cycle*). Import these instead of hand-writing the strings so the two
 * actions stay visibly distinct.
 */

/** Button/menu-item label for starting a new Track. */
export const CREATE_TRACK_LABEL = 'New track';

/** Modal/dialog title for the create-Track flow. */
export const CREATE_TRACK_DIALOG_TITLE = 'New track';

/**
 * Binding a standalone Track to a cycle is ONE act (bind_track_to_cycle) with
 * two doors — from the cycle ("pick a track") and from the track ("pick a
 * cycle"). Canon's word is *bind* (glossary: Unbound / Cycle-Bound Track), so
 * both doors say it. Round 8 retired "Attach existing track", "Add Existing
 * Track", "Accept & Attach" and "Bind to Cycle" / "Accept & Bind".
 */
/** Cycle-side button: bind an existing standalone Track to this cycle (not a create). */
export const ATTACH_TRACK_LABEL = 'Bind existing track';

/** Track-side button: bind this standalone Track to a cycle. */
export const BIND_TRACK_TO_CYCLE_LABEL = 'Bind to cycle';

/** Dialog title for either door. */
export const BIND_TRACK_DIALOG_TITLE = 'Bind track to cycle';

/** Confirm button after reviewing binding conflicts (either door). */
export const BIND_TRACK_CONFIRM_LABEL = 'Bind track';

/** Dialog title while reviewing binding conflicts. */
export const BIND_TRACK_REVIEW_TITLE = 'Review conflicts';

/**
 * Undo a Generate tracks run (owner ruling #6, migration 767 —
 * undo_baseline_tracks_run). One label for the button and the confirm.
 */
export const UNDO_GENERATE_TRACKS_LABEL = 'Undo last Generate tracks';
export const UNDO_GENERATE_TRACKS_TITLE = 'Undo the last Generate tracks run';
